import { useNavigate } from "react-router-dom";
import styles from "../../styles/Vision/Vision.module.css";

const Visions = [
  {
    title: "Deal Validation",
    desc: "Replace assumptions with data through expert analysis.",
  },
  {
    title: "Market Insights",
    desc: "Understand your audience and seize opportunities.",
  },
  {
    title: "Blueprint For Success",
    desc: "A tailored action plan to shape your MVP.",
  },
  {
    title: "Hands-On Guidance",
    desc: "Step-by-step support to bring your idea to life.",
  },
];

const StageVision = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/contact-us", { state: { scrollToForm: true } }); // Pass state
  };
  return (
    <div id={styles.VisionContainer}>
      <div id={styles.VisionInnerContainer}>
        <div id={styles.VisionTitle}>
            Got an Idea? Let’s Turn It Into a Startup That Matters
        </div>

        <div>
          <p id={styles.VisionDesc}>
          Every great startup begins with a bold idea. At LovenCoders, we help you refine, validate, and bring your vision to life with the right strategies and tools to build momentum from day one.
          </p>
        </div>

        <div className={styles.VisionComponentContainer}>
          {Visions.map((vision, index) => (
            <div key={index} className={styles.VisionComponent}>
              <div className={styles.VisionComponentTitle}>{vision.title}</div>
              <div className={styles.VisionComponentDesc}>{vision.desc}</div>
            </div>
          ))}
        </div>

        <div>
          <button className={styles.VisionBtn} onClick={handleGetStarted}>Let’s Build Together</button>
        </div>

        <div id={styles.VisionInfo}>
            Don’t let your idea stay on paper. Click now to transform it into reality with LovenCoders!
        </div>
      </div>
    </div>
  );
};

export default StageVision;
